var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content-data" }, [
    _c(
      "div",
      { staticClass: "data-title" },
      _vm._l(_vm.list, function (item, index) {
        return _c("div", { key: index, staticClass: "data-item" }, [
          _c("div", { staticClass: "data-item-name" }, [
            _vm._v(_vm._s(item.statusLabel)),
          ]),
          _c("div", { staticClass: "data-item-math" }, [
            _vm._v(_vm._s(item.count)),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }